import { defineStore } from "pinia";
import type { TruckService } from "@/services/socket/truck.service";

type TruckStoreState = {
  truckWSService: TruckService | null;
};

export const useTruckStore = defineStore("truckStore", {
  state(): TruckStoreState {
    return {
      truckWSService: null,
    };
  },
  actions: {
    setTruckWSService(service: TruckService | null) {
      this.truckWSService = service;
    },
  },
});
